module.exports = __webpack_public_path__ + "static/media/smart.4171b100.jpg";